/*
 * Fade sections and product cards in as they scroll into view.
 * Turned on in Theme settings -> Animations & loading (adds data-ahh-fade to
 * <body>). The first section (the slider / page top) is left alone so it
 * never flashes. Cards added later (infinite scroll, filters) are picked up too.
 *
 * Don't skip "already on screen" elements by measuring at load: images and
 * the slider haven't sized yet, so the page is short and everything measures
 * as on screen, which switched the fade off everywhere.
 */
(function () {
  if (!document.body.hasAttribute('data-ahh-fade')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = [
    'main .shopify-section',
    '.grid-link__container > .grid__item',
    '.grid-uniform > .grid__item',
    '#c-Loop > .grid__item',
    '#c-loop > .grid__item',
    '.feature-row'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  var first = document.querySelector('main .shopify-section');
  function isTop(el) {
    return first && (el === first || first.contains(el));
  }

  function prepare(root) {
    var els = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    var stagger = 0;
    Array.prototype.forEach.call(els, function (el) {
      if (el.hasAttribute('data-ahh-seen') || el.hasAttribute('data-ahh-skeleton')) return;
      el.setAttribute('data-ahh-seen', '');
      // A section that holds a product grid fades card by card instead.
      if (el.classList.contains('shopify-section') && el.querySelector('.grid__item .grid-link')) return;
      if (isTop(el)) return;
      // Gift guide slides sit side by side in a sideways slider; fading them
      // left re-rendered ones (theme editor) invisible.
      if (el.classList.contains('gg-section')) return;
      if (el.classList.contains('grid__item')) {
        el.style.setProperty('--ahh-reveal-delay', (stagger++ % 4) * 0.08 + 's');
      }
      el.classList.add('ahh-reveal');
      io.observe(el);
    });
  }

  function start() {
    prepare(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SELECTOR)) prepare(n.parentNode);
          else prepare(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
 * Endless scroll: while Ajaxinate fetches the next page, show shimmering
 * placeholder cards at the end of the grid instead of a "Loading" link.
 * Ajaxinate swaps the link text to "Loading" when it starts and appends the
 * new cards when done; we watch for both. The placeholder image uses the
 * same loading style as real cards (Theme settings -> Animations & loading).
 */
(function () {
  var pairs = [['#c-Loop', '#c-Pagination'], ['#c-loop', '#c-pagination']];

  function cardsPerRow(items) {
    if (!items.length) return 4;
    var top = items[0].offsetTop, n = 0;
    for (var i = 0; i < items.length && items[i].offsetTop === top; i++) n++;
    return Math.max(n, 1);
  }

  function watch(loop, pagination) {
    var showing = false;

    function clear() {
      Array.prototype.forEach.call(loop.querySelectorAll('[data-ahh-skeleton]'), function (el) {
        el.parentNode.removeChild(el);
      });
      pagination.classList.remove('ahh-pagination--loading');
      showing = false;
    }

    function show() {
      if (showing) return;
      var items = loop.querySelectorAll(':scope > .grid__item:not([data-ahh-skeleton])');
      if (!items.length) return;
      var model = items[items.length - 1];
      var img = model.querySelector('.grid-link__image');
      var imgHeight = img ? img.offsetHeight : 0;
      var count = cardsPerRow(items) * 2;
      var html = '';
      for (var i = 0; i < count; i++) {
        html += '<div class="' + model.className.replace(/\b(ahh-reveal|is-visible)\b/g, '') +
          '" data-ahh-skeleton aria-hidden="true"><div class="ahh-skeleton">' +
          '<span class="ahh-skeleton__image grid-link__image--loading"' +
          (imgHeight ? ' style="height:' + imgHeight + 'px"' : '') + '></span>' +
          '<span class="ahh-skeleton__line grid-link__image--loading"></span>' +
          '<span class="ahh-skeleton__line ahh-skeleton__line--short grid-link__image--loading"></span>' +
          '</div></div>';
      }
      loop.insertAdjacentHTML('beforeend', html);
      pagination.classList.add('ahh-pagination--loading');
      showing = true;
    }

    // Link text becomes "Loading" -> fetch started.
    new MutationObserver(function () {
      var a = pagination.querySelector('a');
      if (a && /loading/i.test(a.textContent)) show();
      else if (showing) clear();
    }).observe(pagination, { childList: true, subtree: true, characterData: true });

    // New real cards arrived -> placeholders go.
    new MutationObserver(function (mutations) {
      if (!showing) return;
      var real = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && !n.hasAttribute('data-ahh-skeleton');
        });
      });
      if (real) {
        // Keep the new cards after the placeholders' spot: drop placeholders.
        clear();
      }
    }).observe(loop, { childList: true });
  }

  function start() {
    if (document.body.getAttribute('data-ahh-loading') === 'none') return;
    pairs.forEach(function (p) {
      var loop = document.querySelector(p[0]);
      var pagination = document.querySelector(p[1]);
      if (loop && pagination) watch(loop, pagination);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
